'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ThemeContext = require('./ThemeContext');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * HOC that uses ThemeConsumer.
 * @param {React.Component} WrappedComponent - Component that gets theme.
 */
function withTheme(WrappedComponent) {
  return function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'render',
      value: function render() {
        var _this2 = this;

        return _react2.default.createElement(
          _ThemeContext.ThemeConsumer,
          null,
          function (theme) {
            return _react2.default.createElement(WrappedComponent, _extends({ theme: theme }, _this2.props));
          }
        );
      }
    }]);

    return _class;
  }(_react2.default.Component);
}

exports.default = withTheme;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy90aGVtZS9zcmMvd2l0aFRoZW1lLmpzIl0sIm5hbWVzIjpbIndpdGhUaGVtZSIsIldyYXBwZWRDb21wb25lbnQiLCJ0aGVtZSIsInByb3BzIiwiUmVhY3QiLCJDb21wb25lbnQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7QUFBQTs7OztBQUNBOzs7Ozs7Ozs7O0FBRUE7Ozs7QUFJQSxTQUFTQSxTQUFULENBQW1CQyxnQkFBbkIsRUFBcUM7QUFDbkM7QUFBQTs7QUFBQTtBQUFBOztBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBLCtCQUNXO0FBQUE7O0FBQ1AsZUFDRTtBQUFDLHFDQUFEO0FBQUE7QUFDRztBQUFBLG1CQUFTLDhCQUFDLGdCQUFELGFBQWtCLE9BQU9DLEtBQXpCLElBQW9DLE9BQUtDLEtBQXpDLEVBQVQ7QUFBQTtBQURILFNBREY7QUFLRDtBQVBIOztBQUFBO0FBQUEsSUFBcUJDLGdCQUFNQyxTQUEzQjtBQVNEOztrQkFFY0wsUyIsImZpbGUiOiJ3aXRoVGhlbWUuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgeyBUaGVtZUNvbnN1bWVyIH0gZnJvbSAnLi9UaGVtZUNvbnRleHQnXG5cbi8qKlxuICogSE9DIHRoYXQgdXNlcyBUaGVtZUNvbnN1bWVyLlxuICogQHBhcmFtIHtSZWFjdC5Db21wb25lbnR9IFdyYXBwZWRDb21wb25lbnQgLSBDb21wb25lbnQgdGhhdCBnZXRzIHRoZW1lLlxuICovXG5mdW5jdGlvbiB3aXRoVGhlbWUoV3JhcHBlZENvbXBvbmVudCkge1xuICByZXR1cm4gY2xhc3MgZXh0ZW5kcyBSZWFjdC5Db21wb25lbnQge1xuICAgIHJlbmRlcigpIHtcbiAgICAgIHJldHVybiAoXG4gICAgICAgIDxUaGVtZUNvbnN1bWVyPlxuICAgICAgICAgIHt0aGVtZSA9PiA8V3JhcHBlZENvbXBvbmVudCB0aGVtZT17dGhlbWV9IHsuLi50aGlzLnByb3BzfSAvPn1cbiAgICAgICAgPC9UaGVtZUNvbnN1bWVyPlxuICAgICAgKVxuICAgIH1cbiAgfVxufVxuXG5leHBvcnQgZGVmYXVsdCB3aXRoVGhlbWVcbiJdfQ==